import {
  Component,
  ChangeDetectionStrategy,
  Input,
  EventEmitter,
  Output,
  OnChanges,
  SimpleChanges,
} from '@angular/core';
import { ChartTypes } from '@mode/shared/contract-common';
import { DropdownItem } from '../dropdown/dropdown-list.component';

@Component({
  selector: 'mode-format-builder-axis-labels',
  templateUrl: './binned-axis-labels.component.html',
  styleUrls: ['./binned-axis-labels.component.scss'],
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class BinnedAxisLabelsComponent implements OnChanges {
  @Input() binnedAxisLabel?: ChartTypes.BinnedAxisLabelTypeFormat = { type: ChartTypes.BinnedAxisLabelTypes.Auto };
  @Input() menuDisabled = false;
  @Output() update = new EventEmitter<ChartTypes.BinnedAxisLabelTypeFormat>();

  menuItems: Array<DropdownItem> = [
    { name: ChartTypes.BinnedAxisLabelTypes.Auto },
    { name: ChartTypes.BinnedAxisLabelTypes.Continuous },
    { name: ChartTypes.BinnedAxisLabelTypes.First },
  ];
  selected: DropdownItem | undefined = this.menuItems[0];

  ngOnChanges(changes: SimpleChanges): void {
    this.menuItems = this.menuDisabled
      ? [{ name: ChartTypes.BinnedAxisLabelTypes.Auto, disabled: true }]
      : [
          { name: ChartTypes.BinnedAxisLabelTypes.Auto, disabled: false },
          { name: ChartTypes.BinnedAxisLabelTypes.Continuous, disabled: false },
          { name: ChartTypes.BinnedAxisLabelTypes.First, disabled: false },
        ];
    this.selected = this.getAxisLabels(changes[ChartTypes.FieldAxisTypes.BinnedAxisLabel]?.currentValue);
  }

  selectItem(item: DropdownItem) {
    this.selected = item;
    this.binnedAxisLabel = this.makeAxisLabelsTypeFormat(item);
    this.update.emit(this.binnedAxisLabel);
  }

  private getAxisLabels(axisLabels?: ChartTypes.BinnedAxisLabelTypeFormat) {
    let label:
      | ChartTypes.BinnedAxisLabelTypes.Auto
      | ChartTypes.BinnedAxisLabelTypes.First
      | ChartTypes.BinnedAxisLabelTypes.Continuous;
    if (this.menuDisabled) {
      label = ChartTypes.BinnedAxisLabelTypes.Auto;
    } else {
      if (axisLabels?.type === ChartTypes.BinnedAxisLabelTypes.Continuous) {
        label = ChartTypes.BinnedAxisLabelTypes.Continuous;
      } else if (axisLabels?.type === ChartTypes.BinnedAxisLabelTypes.First) {
        label = ChartTypes.BinnedAxisLabelTypes.First;
      } else {
        label = ChartTypes.BinnedAxisLabelTypes.Auto;
      }
    }
    return this.menuItems.find((item) => item.name === label);
  }

  private makeAxisLabelsTypeFormat(item: DropdownItem): ChartTypes.BinnedAxisLabelTypeFormat {
    if (item.name === ChartTypes.BinnedAxisLabelTypes.Continuous) {
      return { type: ChartTypes.BinnedAxisLabelTypes.Continuous };
    } else if (item.name === ChartTypes.BinnedAxisLabelTypes.First) {
      return { type: ChartTypes.BinnedAxisLabelTypes.First };
    } else {
      return { type: ChartTypes.BinnedAxisLabelTypes.Auto };
    }
  }
}
